/**
 * UI adapter: UC-42 GenerateAiNews
 */
import type { CityStats, NewsItem } from '../../../../types';
import { architectureFeatures } from '../../../infrastructure/config/features';
import { generateAiNewsUseCase } from '../../../infrastructure/di/container';
import { GenerateAiNewsUseCase } from '../../../application/use-cases/GenerateAiNewsUseCase';
import { generateNewsEvent } from '../../../../services/geminiService';

export interface ResolveGenerateAiNewsInput {
  stats: CityStats;
  aiEnabled: boolean;
  gateRoll?: number;
}

export interface ResolveGenerateAiNewsOutput {
  ok: boolean;
  news?: NewsItem;
  skipped?: boolean;
}

export async function resolveGenerateAiNews(
  input: ResolveGenerateAiNewsInput,
): Promise<ResolveGenerateAiNewsOutput> {
  if (architectureFeatures.useAiNewsUseCase) {
    return generateAiNewsUseCase.execute(input);
  }

  if (!input.aiEnabled) return { ok: false };
  const gateRoll = input.gateRoll ?? Math.random();
  if (gateRoll > 0.05) return { ok: true, skipped: true };

  const news = await generateNewsEvent(input.stats, null);
  return news ? { ok: true, news } : { ok: false };
}